import React, { useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Alternative PayPal checkout. Renders nothing until PayPal is configured
// server-side (sandbox/live keys set). Amounts are resolved server-side by lookup_key.
export default function PayPalButton({ lookupKey, testid }) {
  const [cfg, setCfg] = useState(null);
  const ref = useRef(null);
  const rendered = useRef(false);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/paypal/config`)
      .then((r) => r.json())
      .then((d) => { if (alive) setCfg(d); })
      .catch(() => { if (alive) setCfg({ enabled: false }); });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!cfg || !cfg.enabled || !cfg.client_id || rendered.current) return;

    const renderButtons = () => {
      if (!window.paypal || !ref.current || rendered.current) return;
      rendered.current = true;
      window.paypal
        .Buttons({
          style: { color: "gold", shape: "pill", height: 44, label: "pay" },
          createOrder: () =>
            fetch(`${API}/paypal/orders`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ lookup_key: lookupKey }),
            })
              .then((r) => r.json())
              .then((d) => d.order_id),
          onApprove: (data) =>
            fetch(`${API}/paypal/orders/${data.orderID}/capture`, { method: "POST" })
              .then((r) => r.json())
              .then(() => { window.location.href = "/payment/success?provider=paypal"; }),
        })
        .render(ref.current);
    };

    if (window.paypal) { renderButtons(); return; }
    const sdkId = "paypal-sdk";
    const existing = document.getElementById(sdkId);
    if (existing) { existing.addEventListener("load", renderButtons); return; }
    const s = document.createElement("script");
    s.id = sdkId;
    s.src = `https://www.paypal.com/sdk/js?client-id=${cfg.client_id}&currency=USD`;
    s.onload = renderButtons;
    document.body.appendChild(s);
  }, [cfg, lookupKey]);

  if (!cfg || !cfg.enabled) return null;
  return <div ref={ref} data-testid={testid || `paypal-${lookupKey}`} style={{ marginTop: 12 }} />;
}
